@if (isMenu) {
  @if (showButton) {
    <button mat-menu-item [attr.aria-label]="'replyAll' | translate">
      <mat-icon>reply_all_outline</mat-icon>
      {{ 'replyAll' | translate }}
    </button>
  }
} @else {
  <app-loading-icon-button
    label="replyAll"
    icon="reply_all_outline"
    [showButton]="showButton"
    [disabled]="disabled"
    [showLoading]="showLoading"></app-loading-icon-button>
}
